import { render } from "./OffCanvas.vue?vue&type=template&id=22c3c92c&scoped=true"
import script from "./OffCanvas.vue?vue&type=script&lang=js"
export * from "./OffCanvas.vue?vue&type=script&lang=js"

import "./OffCanvas.vue?vue&type=style&index=0&id=22c3c92c&scoped=true&lang=css"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/71-Garfield/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c3c92c"]])

export default __exports__